var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('KitchenConfidentialArticle'),_c('TheHundredYearsWarOnPalestineArticle'),_c('TheAgeOfDiagnosisArticle'),_c('OneDayEveryoneWillAlwaysHaveBeenAgainstThisArticle'),_c('BeyondTheWallArticle'),_c('IfThisIsAManTheTruceArticle'),_c('KillingThatcherArticle')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }